import React, {useState} from 'react'
import { Button } from 'react-bootstrap';


const DoorDash = () => {
    const [isHovered, setIsHovered] = useState(false);
      const buttonStyle = {
          backgroundColor: isHovered ? '#E02B07' : '#FF3008',
          borderColor: isHovered ? '#E02B07' : '#FF3008',
          color: '#FFFFFF',
          fontWeight: '700',
          fontSize: '0.95rem',
          padding: '10px 24px',
          borderRadius: '24px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease-in-out',
          transform: isHovered ? 'translateY(-1px)' : 'translateY(0)',
          textDecoration: 'none',
          display: 'inline-block'
        };
  return (
    <div>
        
              <Button
                href={"https://www.doordash.com/en-CA/store/nostalgia-kitchen-toronto-23046167/12756939/?srsltid=AU7gw4XiyoAE9a1mmWp_5XeflrCViYoLPy_dsLwEoqCUiE6NpYg1rWwJ"}
                target="_blank"
                rel="noopener noreferrer"
                style={buttonStyle}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
   
                <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Doordash--Streamline-Simple-Icons" height="24" width="24">
                <desc>
                  Doordash Streamline Icon: https://streamlinehq.com
                </desc>
                <title>DoorDash</title>
                <path 
                d="M23.071 8.409a6.09 6.09 0 0 0 -5.396 -3.228H0.584A0.589 0.589 0 0 0 0.17 6.184L3.894 9.93a1.752 1.752 0 0 0 1.242 0.516h12.049a1.554 1.554 0 1 1 0.031 3.108H8.91a0.589 0.589 0 0 0 -0.415 1.003l3.725 3.747a1.75 1.75 0 0 0 1.242 0.516h3.757c4.887 0 8.584 -5.225 5.852 -10.413" fill="white" stroke-width="1"></path>
              </svg> {" "}
                Order on DoorDash
              </Button>
    </div>
  )
}

export default DoorDash
